// apps/web/src/pages/admin/today/TodaySortChips.tsx — Phase 5 plan 05-04 (D-04).
//
// Client-side sort selector with the 3 options from the wireframe B2
// layout. The selected sort key is bubble-up via `onChange`.

import { useTranslation } from "react-i18next";

export type TodaySortKey = "time" | "name" | "party";

export function TodaySortChips({
  value,
  onChange,
}: {
  value: TodaySortKey;
  onChange: (next: TodaySortKey) => void;
}) {
  const { t } = useTranslation();
  const options: TodaySortKey[] = ["time", "name", "party"];
  return (
    <div
      className="flex gap-2 mb-4"
      role="radiogroup"
      aria-label={t("admin.today.sortChips.label")}
      data-testid="today-sort-chips"
    >
      {options.map((opt) => (
        <button
          key={opt}
          type="button"
          role="radio"
          aria-checked={value === opt}
          onClick={() => onChange(opt)}
          className={`btn ${value === opt ? "btn-primary" : "btn-outline"}`}
          data-testid={`sort-chip-${opt}`}
        >
          {t(`admin.today.sortChips.${opt}`)}
        </button>
      ))}
    </div>
  );
}
